import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../utils/Utils"

class SezioneUndici extends Component {

    state = {
        sezioneUndici: {
            dataPrelievoSangue: "",
            positivoHBsAg: "",
            positivoAntiHBC: "",
            positivoAntiEpatiteA: "",
            positivoAntiDelta: "",
            positivoAntiHCV: "",
            positivoHCVRNA: "",
            positivoAntiEpatiteE: "",
            livelloViremia: "",
            corretto: []
        }


    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneUndici) {
            let sezioneUndici = this.state.sezioneUndici
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneUndici))
            sezioneUndici.dataPrelievoSangue = propsSezione.dataPrelievoSangue ? propsSezione.dataPrelievoSangue : ""
            sezioneUndici.positivoHBsAg = propsSezione.positivoHBsAg ? propsSezione.positivoHBsAg : ""
            sezioneUndici.positivoAntiHBC = propsSezione.positivoAntiHBC ? propsSezione.positivoAntiHBC : ""
            sezioneUndici.positivoAntiEpatiteA = propsSezione.positivoAntiEpatiteA ? propsSezione.positivoAntiEpatiteA : ""
            sezioneUndici.positivoAntiHCV = propsSezione.positivoAntiHCV ? propsSezione.positivoAntiHCV : ""
            sezioneUndici.positivoHCVRNA = propsSezione.positivoHCVRNA ? propsSezione.positivoHCVRNA : ""
            sezioneUndici.positivoAntiEpatiteE = propsSezione.positivoAntiEpatiteE ? propsSezione.positivoAntiEpatiteE : ""
            sezioneUndici.livelloViremia = propsSezione.livelloViremia ? propsSezione.livelloViremia : ""
            sezioneUndici.positivoAntiDelta = propsSezione.positivoAntiDelta ? propsSezione.positivoAntiDelta : ""
            this.setState({sezioneUndici: sezioneUndici})
        }
        this.controllaDati();
        this.props.setSezioneUndici(this.state.sezioneUndici)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneUndici(this.state.sezioneUndici, this.validate(), res)
        }
    }

    validate() {

        if (this.state.sezioneUndici.dataPrelievoSangue) {
            let validatedataPrelievoSangue = Utils.checkDateInterval(this.state.sezioneUndici.dataPrelievoSangue, "31/12/1899");
            let validatedataPrelievoSangueOdierna = Utils.checkDateInterval(this.state.sezioneUndici.dataPrelievoSangue, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataPrelievoSangue) {
                return "Messages.DataPrelievoSangue"
            } else if (!validatedataPrelievoSangueOdierna) {
                return "Messages.DataPrelievoSangueOdierna"
            }
        }

        if (this.state.sezioneUndici.positivoHCVRNA !== "01" && this.state.sezioneUndici.livelloViremia) return "Messages.ERR_01_02_0D_BC"

        return ""

    }

    riceviValoreRadioButton(event, field) {
        let sezioneUndici = this.state.sezioneUndici
        sezioneUndici[field] = event

        this.setState({sezioneUndici: sezioneUndici})
    }

    riceviValoreInput(field, event) {

        let sezioneUndici = this.state.sezioneUndici
        if (field.currentTarget) {
            sezioneUndici[field.currentTarget.id] = field.currentTarget.value
        } else {
            sezioneUndici[field] = event.target.value
        }
        this.setState({sezioneUndici: sezioneUndici})
    }

    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneUndici))
        let sezione = Utils.removeEmptyValueFromObject(dati)
        return Utils.removeFieldFromObject(sezione, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneUndici
        dati.corretto = []

        if(dati.dataPrelievoSangue && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataPrelievoSangue), "-")) dati.corretto[0] = "Campo \"Data del prelievo del sangue\" errato";
        if(!dati.positivoHBsAg) dati.corretto[1] = "Campo \"È positivo per HBsAg?\" mancante";
        if(!dati.positivoAntiHBC) dati.corretto[2] = "Campo \"È positivo per IgM anti-HBc?\" mancante";
        if(!dati.positivoAntiEpatiteA) dati.corretto[3] = "Campo \"È positivo per IgM anti-Epatite A?\" mancante";
        if(!dati.positivoAntiDelta) dati.corretto[4] = "Campo \"È positivo per Igm anti-Delta?\" mancante";
        if(!dati.positivoAntiHCV) dati.corretto[5] = "Campo \"È positivo per Igm anti-hcv?\" mancante";
        if(!dati.positivoHCVRNA) dati.corretto[6] = "Campo \"È positivo per Igm HCV-RNA?\" mancante";
        if(!dati.positivoAntiEpatiteE) dati.corretto[7] = "Campo \"È positivo per IgM anti-Epatite E?\" mancante";
        if(dati.positivoHCVRNA === "01" && !dati.livelloViremia) dati.corretto[8] = "Campo \"Se sì, livello viremia\" mancante";

    }

    render() {

        const {t} = this.props;

        const sezioneUndici = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 11</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaUno")}</b>
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                            <Calendar
                                id={"dataPrelievoSangue"}
                                field={"dataPrelievoSangue"}
                                value={this.state.sezioneUndici.dataPrelievoSangue}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneUndici.dataPrelievoSangue === "" ||
                                    this.state.sezioneUndici.dataPrelievoSangue == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneUndici.dataPrelievoSangue), "-")}>
                            </Calendar>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaDue")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"positivoHBsAgSi"}
                                             name={"positivoHBsAg"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                    //onClick={this.setRicovero}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoHBsAg")}
                                             checked={this.state.sezioneUndici.positivoHBsAg === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoHBsAgNo"}
    name={"positivoHBsAg"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "positivoHBsAg")}
    checked={this.state.sezioneUndici.positivoHBsAg === "02"}
    />
                                <RadioButton id={"positivoHBsAgNoRic"}
    name={"positivoHBsAg"} label={t("SchedaEpatite.sezione11.nonRicercato")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "positivoHBsAg")}
    checked={this.state.sezioneUndici.positivoHBsAg === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaTre")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"positivoAntiHBCSo"}
                                             name={"positivoAntiHBC"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoAntiHBC")}
                                             checked={this.state.sezioneUndici.positivoAntiHBC === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoAntiHBCNo"}
    name={"positivoAntiHBC"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "positivoAntiHBC")}
    checked={this.state.sezioneUndici.positivoAntiHBC === "02"}
    />
                                <RadioButton id={"positivoAntiHBCNonRic"}
    name={"positivoAntiHBC"} label={t("SchedaEpatite.sezione11.nonRicercato")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "positivoAntiHBC")}
    checked={this.state.sezioneUndici.positivoAntiHBC === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaQuattro")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"positivoAntiEpatiteASi"}
                                             name={"positivoAntiEpatiteA"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoAntiEpatiteA")}
                                             checked={this.state.sezioneUndici.positivoAntiEpatiteA === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoAntiEpatiteANo"}
    name={"positivoAntiEpatiteA"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "positivoAntiEpatiteA")}
    checked={this.state.sezioneUndici.positivoAntiEpatiteA === "02"}
    />
                                <RadioButton id={"positivoAntiEpatiteANonRic"}
    name={"positivoAntiEpatiteA"}
    label={t("SchedaEpatite.sezione11.nonRicercato")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "positivoAntiEpatiteA")}
    checked={this.state.sezioneUndici.positivoAntiEpatiteA === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaCinque")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"positivoAntiDeltaSi"}
                                             name={"positivoAntiDelta"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoAntiDelta")}
                                             checked={this.state.sezioneUndici.positivoAntiDelta === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoAntiDeltaNo"}
    name={"positivoAntiDelta"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "positivoAntiDelta")}
    checked={this.state.sezioneUndici.positivoAntiDelta === "02"}
    />
                                <RadioButton id={"positivoAntiDeltaNonRic"}
    name={"positivoAntiDelta"}
    label={t("SchedaEpatite.sezione11.nonRicercato")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "positivoAntiDelta")}
    checked={this.state.sezioneUndici.positivoAntiDelta === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaSei")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"positivoAntiHCVSi"}
                                             name={"positivoAntiHCV"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoAntiHCV")}
                                             checked={this.state.sezioneUndici.positivoAntiHCV === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoAntiHCVNo"}
    name={"positivoAntiHCV"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "positivoAntiHCV")}
    checked={this.state.sezioneUndici.positivoAntiHCV === "02"}
    />
                                <RadioButton id={"positivoAntiHCVNonRic"}
    name={"positivoAntiHCV"} label={t("SchedaEpatite.sezione11.nonRicercato")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "positivoAntiHCV")}
    checked={this.state.sezioneUndici.positivoAntiHCV === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaSette")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"positivoHCVRNASi"}
                                             name={"positivoHCVRNA"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoHCVRNA")}
                                             checked={this.state.sezioneUndici.positivoHCVRNA === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoHCVRNANo"}
    name={"positivoHCVRNA"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "positivoHCVRNA")}
    checked={this.state.sezioneUndici.positivoHCVRNA === "02"}
    />
                                <RadioButton id={"positivoHCVRNANonRic"}
    name={"positivoHCVRNA"} label={t("SchedaEpatite.sezione11.nonRicercato")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "positivoHCVRNA")}
    checked={this.state.sezioneUndici.positivoHCVRNA === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaOtto")}</b>
                                {this.state.sezioneUndici.positivoHCVRNA === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <Input
                                id={"livelloViremia"}
                                type="number"
                                min="0"
                                max={"9999999"}
                                onChange={this.riceviValoreInput}
                                field={"livelloViremia"}
                                value={this.state.sezioneUndici.livelloViremia}
                                placeholder={"livelloViremia"}
                            >
                            </Input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione11.domandaNove")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"positivoAntiEpatiteESi"}
                                             name={"positivoAntiEpatiteE"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoAntiEpatiteE")}
                                             checked={this.state.sezioneUndici.positivoAntiEpatiteE === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoAntiEpatiteENo"}
    name={"positivoAntiEpatiteE"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "positivoAntiEpatiteE")}
    checked={this.state.sezioneUndici.positivoAntiEpatiteE === "02"}
    />
                                <RadioButton id={"positivoAntiEpatiteENonRic"}
    name={"positivoAntiEpatiteE"}
    label={t("SchedaEpatite.sezione11.nonRicercato")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "positivoAntiEpatiteE")}
    checked={this.state.sezioneUndici.positivoAntiEpatiteE === "03"}
    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneUndici}
        </div>
    }


}

export default withTranslation('common')(SezioneUndici)
